import { FC, useEffect, useState } from "react";

import { ICookieVerificationProps } from "./ICookieVerificationProps";
import { useAuth } from "../../../../../modules/auth";
import useCookieStore from "../useCookieStore";
import { useLazyGetCookiesDeviceIdQuery } from "../registration/cookieApi";

export interface IVerificationProps extends ICookieVerificationProps {
    children?: React.ReactNode;
}

const invalidPrompt = <span>Your device registration is invalid for attendance marking. Please refer your <span className="fw-bold">'Device Registration'</span> in application's site-navigation.</span>;
const createdPrompt = <span>Your registration for this device is initiated and you will be able to mark attendance once 'Registered'</span>;
const notRegistered = <span>You are not registered on this device for attendance marking. Please refer your <span className="fw-bold">'Device Registration'</span> in the application's site-navigation.</span>;

export const CookieVerification: FC<IVerificationProps> = ({
    children, cookieName, validAfterMins
}) => {
    const { user } = useAuth()
    const { hasValidCookie } = useCookieStore(cookieName)
    const [validity, setValidity] = useState<"VALID" | "CREATED" | "INVALID">()
    const [serverIdentifier, setServerIdentifier] = useState<string>('');
    const [getCookiesDeviceId] = useLazyGetCookiesDeviceIdQuery();
    const [isServerIdentifierReady, setIsServerIdentifierReady] = useState<boolean>(false);

    useEffect(() => {
        if (!user || !user.contactId) return;

        getCookiesDeviceId({
            contactId: user.contactId
        }).unwrap()
            .then((result) => {
                if (result) {
                    setServerIdentifier(result.deviceId);
                    setIsServerIdentifierReady(true);
                } else {
                    console.warn("Failed to retrieve server identifier");
                }
            })
            .catch((err) => console.error("Error fetching server identifier:", err));
    }, [getCookiesDeviceId, user]);

    useEffect(() => {
        const contactId = user?.userId;
        if (!contactId || !isServerIdentifierReady) return;

        const validateCookie = async () => {
            const result = await hasValidCookie(contactId, validAfterMins, serverIdentifier);
            setValidity(result);
        };

        validateCookie();
        // eslint-disable-next-line
    }, [user, isServerIdentifierReady, serverIdentifier]);

    if (validity === "VALID") {
        return <>{children}</>
    }

    return <div className="d-flex gap-1 align-items-center">
        {(!validity) && <span>{notRegistered}</span>}
        {(validity === "INVALID") && <span>{invalidPrompt}</span>}
        {(validity === "CREATED") && <span>{createdPrompt}</span>}
    </div>
}
